import { Trans } from '@lingui/react/macro';
import { useState } from 'react';

import { Checkmark } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';
import { getRouteApi } from '@tanstack/react-router';

import { ButtonClicked } from 'src/ampli';
import { tracker } from 'src/analytics/tracker';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { Button } from 'src/components';

import { CancelConnectSurveyForm } from './CancelConnectSurveyForm';

const routeApi = getRouteApi('/_auth/_layout/subscriptions/plan');

export const CancelConnectSurvey = () => {
  const navigate = routeApi.useNavigate();
  const [selectedSurveyAnswer, setSelectedSurveyAnswer] = useState<
    string | null
  >(null);

  const handleSubmit = () => {
    tracker.trackEvent(
      new ButtonClicked({
        component_location: ComponentLocations.SURVEY.ANSWER,
        text: selectedSurveyAnswer || '',
        action: 'respond to survey',
      })
    );

    void navigate({ search: { cancel_subscription: 'confirmation' } });
  };

  return (
    <div
      className="flex h-full flex-col items-center justify-between gap-24 text-center"
      data-cy="mrf-step-5"
    >
      <div className="flex h-full flex-col items-center gap-24 ls:px-24 lm:flex-row lm:gap-48 lxl:px-64">
        <div className="flex w-fit flex-1 flex-col justify-center text-center lm:basis-1/2 lm:text-left">
          <Typography variant="heading-subtle-xl">
            <Trans>Cancellation confirmed</Trans>
          </Typography>
          <Typography variant="responsive-heading-lg" className="my-24" as="h1">
            <Trans>Can you tell us why you&apos;re leaving?</Trans>
          </Typography>
        </div>
        <div className="flex justify-center lm:basis-1/2">
          <CancelConnectSurveyForm
            selectedAnswer={selectedSurveyAnswer}
            setSelectedAnswer={setSelectedSurveyAnswer}
          />
        </div>
      </div>

      <div className="flex w-full justify-end">
        <Button
          disabled={selectedSurveyAnswer === null}
          as="button"
          variant="tertiary-neutral"
          data-cy="cancel-subscription-survey"
          onClick={handleSubmit}
        >
          <>
            <span>
              <Trans>Submit</Trans>
            </span>{' '}
            <Checkmark />
          </>
        </Button>
      </div>
    </div>
  );
};
